import { AxiosPromise } from 'axios';
import * as servicesControlPanel from 'src/app/services/control-panel/control-panel.service.type';
import { axios } from 'src/app/utils';
import { finalUrlsConfig } from 'src/configs/url.config';

export const getAllModules = (): AxiosPromise<servicesControlPanel.AllModulesResultType> => {
  return axios.get(finalUrlsConfig().controlPanel.modules);
};

export const startModule = (
  moduleInformation: servicesControlPanel.StartModuleDataType,
  options: { blockErrorHandler: boolean },
): AxiosPromise<servicesControlPanel.GetStartModuleResultType> => {
  return axios.patch(finalUrlsConfig().controlPanel.start, moduleInformation, options);
};

export const stopModule = (
  moduleInformation: servicesControlPanel.StopModuleDataType,
  options: { blockErrorHandler: boolean },
): AxiosPromise<servicesControlPanel.GetStopModuleResultType> => {
  return axios.patch(finalUrlsConfig().controlPanel.stop, moduleInformation, options);
};

export const restartModule = (
  moduleInformation: servicesControlPanel.RestartModuleDataType,
  options: { blockErrorHandler: boolean },
): AxiosPromise<servicesControlPanel.GetRestartModuleResultType> => {
  return axios.patch(finalUrlsConfig().controlPanel.restart, moduleInformation, options);
};

export const getRunningModules = (): AxiosPromise<servicesControlPanel.GetRunningControlPanelResultType> => {
  return axios.get(finalUrlsConfig().controlPanel.running);
};

export const getInstalledModules = (): AxiosPromise<servicesControlPanel.GetInstalledControlPanelResultType> => {
  return axios.get(finalUrlsConfig().controlPanel.installed);
};

export const multipleConfig = (
  multipleConfigDto: servicesControlPanel.SocketModule,
): AxiosPromise<servicesControlPanel.SocketModule> => {
  return axios.post(
    finalUrlsConfig().controlPanel.multipleConfig,
    { module: multipleConfigDto },
    { blockSpinner: true },
  );
};
